<template>
    <div>
        <div class="regisInfo">
            <div class="left">
                <div class="title">
                    {{ form.zpjhmc }}
                </div>
            </div>
            <div class="view" @click="showOrHide()">
                {{ detailMessage[showDetails ? 1 : 0] }}
            </div>
            <div class="right">
                <span v-show="!editFileing" @click="modifyRegisInfo">修改</span>
                <span v-show="!editing" @click="modifyFileInfo">更新附件</span>
                <span @click="deleteRegisInfo">删除</span>
            </div>
        </div>
        <el-form ref="form" :model="form" :rules="rules" label-position="right" label-width="150px" v-show="showDetails">
            <div class="header">
                <div>基本信息</div>
            </div>
            <el-row>
                <el-col :span="16">
                    <el-col :span="12">
                        <el-form-item label="身份证号" prop="sfzhm">
                            <el-input v-model="form.sfzhm" placeholder="请输入" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="xm">
                            <el-input v-model="form.xm" placeholder="请输入" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别" prop="xb">
                            <el-select v-model="form.xb" style="width: 100%" :disabled="!editing">
                                <el-option v-for="item in options.genderList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="民族" prop="mz">
                            <el-select v-model="form.mz" style="width: 100%" :disabled="!editing">
                                <el-option v-for="item in options.nationList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="出生年月" prop="csny">
                            <el-date-picker
                                v-model="form.csny"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择"
                                style="width: 100%"
                                :disabled="!editing"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="政治面貌" prop="zzmm">
                            <el-select v-model="form.zzmm" style="width: 100%" :disabled="!editing">
                                <el-option v-for="item in options.politicsFaceList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号码" prop="lxdh">
                            <el-input v-model="form.lxdh" placeholder="请输入" :disabled="!editing"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="籍贯" prop="jg">
                            <el-cascader style="width: 100%;" clearable :options="provinceAndCityData" v-model="form.jg" :disabled="!editing"> </el-cascader>
                            <!-- <el-input v-model="form.jg" placeholder="请输入" :disabled="!editing"></el-input> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身高（cm）" prop="sg">
                            <el-input v-model="form.sg" style="width: 100%;" placeholder="请输入" :disabled="!editing"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="体重（kg）" prop="tz">
                            <el-input v-model="form.tz" style="width: 100%;" placeholder="请输入" :disabled="!editing"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                        
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="英语水平" prop="yysp">
                            <el-select v-model="form.yysp" style="width: 100%" :disabled="!editing">
                                <el-option v-for="item in options.yyspList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="计算机水平" prop="jsjsp">
                            <el-select v-model="form.jsjsp" style="width: 100%" :disabled="!editing">
                                <el-option v-for="item in options.jsjspList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="在校职务" prop="zw">
                            <el-input v-model="form.zw" placeholder="请输入" :disabled="!editing"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="获奖情况及特长" prop="hjqkjtc">
                            <el-input v-model="form.hjqkjtc" type="textarea" placeholder="请输入" :disabled="!editing"></el-input>
                        </el-form-item>
                    </el-col> -->
                </el-col>
                <el-col :span="8">
                    <div class="baseinfo-image">
                        <div style="font-size: 14px; color:#606266;">
                            <span class="red">*&nbsp;</span>个人照片
                        </div>
                        <img class="image" :src="form.imageSrc" />
                        <el-upload action="" :on-change="imageChange" :show-file-list="false" :auto-upload="false">
                            <el-button size="small" type="primary" v-show="editing">上传图片</el-button>
                        </el-upload>
                        <div class="red" :class="{ show: showMessage, hide: !showMessage }">
                            请上传个人照片
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div class="header">
                <div>学习经历</div>
            </div>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="学历" prop="dyxl">
                        <el-select v-model="form.dyxl" placeholder="请选择" style="width: 100%" :disabled="!editing"  @change="changeDyxl">
                            <el-option v-for="item in options.educationList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="是否国外院校" prop="sfgwyx">
                        <el-select v-model="form.sfgwyx" placeholder="请选择" style="width: 100%;" @change="changeSfgwyx" :disabled="!editing">
                            <el-option v-for="item in options.sfgwyxList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="毕业学校" prop="dyxlbyxx">
                        <el-input
                            placeholder="请输入"
                            v-model="form.dyxlbyxx"
                            class="input-with-select"
                            :disabled="!editing"
                        >
                            <el-button
                                @click="searchUniversity('dyxlbyxx')"
                                slot="append"
                                icon="el-icon-search"
                                :disabled="!editing"
                                v-if="showByxxSearchButton"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="入学时间" prop="rxsj">
                        <el-date-picker
                            v-model="form.rxsj"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择"
                            style="width: 100%;"
                            :disabled="!editing"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="毕业时间" prop="bysj">
                        <el-date-picker
                            v-model="form.bysj"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择"
                            style="width: 100%"
                            :disabled="!editing"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="所学专业" prop="dyxlsxzy">
                        <el-input
                            placeholder="请输入"
                            v-model="form.dyxlsxzy"
                            class="input-with-select"
                            :disabled="!editing"
                            @change="changeDyxlsxzy"
                        >
                            <el-button
                                @click="searchMajor"
                                slot="append"
                                icon="el-icon-search"
                                :disabled="!editing"
                                v-if="showSxzySearchButton"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="院校类别" prop="xxlb">
                        <el-select v-model="form.xxlb" placeholder="请选择" style="width: 100%" :disabled="!editing">
                            <el-option v-for="item in options.collegeList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="教育形式" prop="jyxs">
                        <el-select v-model="form.jyxs" placeholder="请选择" style="width: 100%" :disabled="!editing">
                            <el-option v-for="item in options.jyxsList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="研究方向" prop="zyyjfx">
                        <el-input v-model="form.zyyjfx" placeholder="请输入" :disabled="!editing"></el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="英语水平" prop="yysp">
                        <el-select v-model="form.yysp" style="width: 100%" :disabled="!editing">
                            <el-option v-for="item in options.yyspList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="计算机水平" prop="jsjsp">
                        <el-select v-model="form.jsjsp" style="width: 100%" :disabled="!editing">
                            <el-option v-for="item in options.jsjspList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="在校职务" prop="zw">
                        <el-input v-model="form.zw" placeholder="请输入" :disabled="!editing"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="获奖情况及特长" prop="hjqkjtc">
                        <el-input v-model="form.hjqkjtc" type="textarea" placeholder="请输入" show-word-limit maxlength="500" :autosize = "{ minRows: 3}" :disabled="!editing"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="form.dyxl === '11' || form.dyxl === '14'">
                <el-col :span="8">
                    <el-form-item label="本科毕业学校" prop="bkbyxx">
                        <el-input
                            placeholder="请输入"
                            v-model="form.bkbyxx"
                            class="input-with-select"
                            :disabled="!editing"
                        >
                            <el-button
                                @click="searchUniversity('bkbyxx')"
                                slot="append"
                                icon="el-icon-search"
                                :disabled="!editing"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="本科所学专业" prop="bksxzy">
                        <el-input
                            placeholder="请输入"
                            v-model="form.bksxzy"
                            class="input-with-select"
                            :disabled="!editing"
                        >
                            <el-button
                                @click="searchBkMajor"
                                slot="append"
                                icon="el-icon-search"
                                :disabled="!editing"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="header">
                <div>其他</div>
            </div>
            <el-dialog title="招聘岗位查询/选择" :visible.sync="zpzyLov.show" width="80%">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="所属板块" label-width="80px">
                            <el-select v-model="zpzyLov.ssbk" placeholder="请选择" style="width: 100%">
                                <el-option v-for="item in zpzyLov.ssbkOptions" :key="item.key + item.value" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="岗位类别" label-width="80px">
                            <el-input v-model="zpzyLov.gwlb" placeholder="请输入"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="专业类别" label-width="80px">
                            <el-input v-model="zpzyLov.zylb" placeholder="请输入"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2" :offset="1">
                        <el-button type="primary" @click="queryZpzy">查询</el-button>
                    </el-col>
                </el-row>

                <el-table :data="zpzyLov.table" style="width: 100%" @row-dblclick="tableRowDbclickBackfill">
                    <el-table-column prop="ssbkmc" label="所属板块"> </el-table-column>
                    <el-table-column prop="gwlb" label="岗位类别"> </el-table-column>
                    <el-table-column prop="zylb" label="专业类别"> </el-table-column>
                </el-table>
            </el-dialog>
            <el-row>
                <el-col :span="16">
                    <el-form-item label="拟应聘岗位" prop="gwlbmc">
                        <el-input
                            placeholder="请选择"
                            v-model="form.gwlbmc"
                            class="input-with-select"
                            :disabled="!editing"
                        >
                            <el-button
                                @click="searchGw"
                                slot="append"
                                icon="el-icon-search"
                                :disabled="!editing"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="是否有服兵役经历" prop="sfyfbyjl">
                        <el-select v-model="form.sfyfbyjl" placeholder="请选择" style="width: 100%;" @change="changeSfyfbyjl" :disabled="!editing">
                            <el-option v-for="item in options.sfyfbyjlList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="服兵役开始时间" prop="fbykssj" :rules="form.sfyfbyjl === '0' ? rules.fbykssj:[{required: true, message: '请选择服兵役开始时间', trigger: ['change']}]" :disabled="!editing">
                        <el-date-picker v-model="form.fbykssj" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width: 100%;" :disabled="!editing">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="服兵役结束时间" prop="fbyjssj" :rules="form.sfyfbyjl === '0' ? rules.fbyjssj:[{required: true, message: '请选择服兵役结束时间', trigger: ['change']}]" :disabled="!editing">
                        <el-date-picker v-model="form.fbyjssj" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width: 100%;" :disabled="!editing">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注" prop="bz">
                        <el-input v-model="form.bz" type="textarea" placeholder="学习经历、社会实践等" show-word-limit maxlength="500" :autosize = "{ minRows: 3}" :disabled="!editing"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div v-show="editFileing" class="header">
                <div>附件上传<span style="color: red; margin-left: 5px; font-weight: 100; font-size: 13px;">（注意：附件格式统一为PDF、JPG或DOCX，可使用扫描仪扫描、手机拍照（必须平整），建议附件按"学校名称-专业名称-姓名-附件类型"重命名后分类上传）</span></div>
            </div>
            <!-- <el-row v-show="editFileing" style="margin-bottom: 10px">
                <el-col :span="23" :offset="1">
                    <span style="color: red;">
                        上传格式统一为PDF、JPG或DOCX，材料可使用扫描仪扫描、手机拍照（必须平整），建议材料按"学校名称-专业名称-姓名-求职简历.PDF"、"学校名称-专业名称-姓名-成绩表.PDF"、"学校名称-专业名称-姓名-就业推荐表.PDF"、"学校名称-专业名称-姓名-就业协议书.PDF"重命名后分类上传，单个上传文件不能超过10M，就业协议书请在签约后上传。
                    </span>
                </el-col>
            </el-row> -->
            <el-row v-show="editFileing" style="margin-bottom: 10px">
                <el-col :span="5">
                    <el-form-item label="求职简历" required>
                        <el-upload action="" :multiple="false" :on-change="qzjlUploadChange" :auto-upload="false" :limit="1">
                            <el-button type="primary">点击上传</el-button>
                        </el-upload>
                        <el-row>
                            <el-col :span="24">
                                <div class="file-upload">
                                    <div class="success">
                                        <div v-for="(item, index) in qzjlFileSuccessList" :key="item.uid">
                                            {{ item.raw.name + "  " }}
                                            <span class="delete" @click="deleteFile(index,'1')">删除</span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="成绩表">
                        <el-upload action="" :multiple="false" :on-change="cjbUploadChange" :auto-upload="false" :limit="1">
                            <el-button type="primary">点击上传</el-button>
                        </el-upload>
                        <el-row>
                            <el-col :span="24">
                                <div class="file-upload">
                                    <div class="success">
                                        <div v-for="(item, index) in cjbFileSuccessList" :key="item.uid">
                                            {{ item.raw.name + "  " }}
                                            <span class="delete" @click="deleteFile(index,'2')">删除</span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="就业推荐表">
                        <el-upload action="" :multiple="false" :on-change="jytjbUploadChange" :auto-upload="false" :limit="1">
                            <el-button type="primary">点击上传</el-button>
                        </el-upload>
                        <el-row>
                            <el-col :span="24">
                                <div class="file-upload">
                                    <div class="success">
                                        <div v-for="(item, index) in jytjbFileSuccessList" :key="item.uid">
                                            {{ item.raw.name + "  " }}
                                            <span class="delete" @click="deleteFile(index,'3')">删除</span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="就业协议书">
                        <el-upload action="" :multiple="false" :on-change="jyxysUploadChange" :auto-upload="false" :limit="1">
                            <el-button type="primary">点击上传</el-button>
                        </el-upload>
                        <el-row>
                            <el-col :span="24">
                                <div class="file-upload">
                                    <div class="success">
                                        <div v-for="(item, index) in jyxysFileSuccessList" :key="item.uid">
                                            {{ item.raw.name + "  " }}
                                            <span class="delete" @click="deleteFile(index,'4')">删除</span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="5" :offset="1">
                    <el-upload action="" :multiple="false" :on-change="qzjlUploadChange" :auto-upload="false" :limit="1">
                        <el-button type="primary">上传求职简历</el-button>
                    </el-upload>
                    <el-row>
                        <el-col :span="24"
                            ><div class="file-upload" v-if="qzjlFileFailList.length > 0 || qzjlFileSuccessList.length > 0">
                                <div class="success">
                                    <div>上传成功文件</div>
                                    <div v-for="(item, index) in qzjlFileSuccessList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span class="delete" @click="deleteFile(index,'1')">删除</span>
                                    </div>
                                </div>
                                <div class="fail" v-if="qzjlFileFailList.length > 0">
                                    <div>上传失败文件</div>
                                    <div v-for="(item, index) in qzjlFileFailList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span style="color: #2a8ae0; cursor: pointer" @click="reUploadFile(index,'1')">
                                            重新上传
                                        </span>
                                        <span class="delete" @click="removeFile(index,'1')">{{ "删除    " }}</span>
                                    </div>
                                </div>
                            </div></el-col
                        >
                    </el-row>
                    
                </el-col>
                
                <el-col :span="5" :offset="1">
                    <el-upload action="" :multiple="false" :on-change="cjbUploadChange" :auto-upload="false" :limit="1">
                        <el-button type="primary">上传成绩表</el-button>
                    </el-upload>
                    <el-row>
                        <el-col :span="24"
                            ><div class="file-upload" v-if="cjbFileFailList.length > 0 || cjbFileSuccessList.length > 0">
                                <div class="success">
                                    <div>上传成功文件</div>
                                    <div v-for="(item, index) in cjbFileSuccessList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span class="delete" @click="deleteFile(index,'2')">删除</span>
                                    </div>
                                </div>
                                <div class="fail" v-if="cjbFileFailList.length > 0">
                                    <div>上传失败文件</div>
                                    <div v-for="(item, index) in cjbFileFailList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span style="color: #2a8ae0; cursor: pointer" @click="reUploadFile(index,'2')">
                                            重新上传
                                        </span>
                                        <span class="delete" @click="removeFile(index,'2')">{{ "删除    " }}</span>
                                    </div>
                                </div>
                            </div></el-col
                        >
                    </el-row>
                </el-col>
                <el-col :span="5" :offset="1">
                    <el-upload action="" :multiple="false" :on-change="jytjbUploadChange" :auto-upload="false" :limit="1">
                        <el-button type="primary">上传就业推荐表</el-button>
                    </el-upload>
                    <el-row>
                        <el-col :span="24"
                            ><div class="file-upload" v-if="jytjbFileFailList.length > 0 || jytjbFileSuccessList.length > 0">
                                <div class="success">
                                    <div>上传成功文件</div>
                                    <div v-for="(item, index) in jytjbFileSuccessList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span class="delete" @click="deleteFile(index,'3')">删除</span>
                                    </div>
                                </div>
                                <div class="fail" v-if="jytjbFileFailList.length > 0">
                                    <div>上传失败文件</div>
                                    <div v-for="(item, index) in jytjbFileFailList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span style="color: #2a8ae0; cursor: pointer" @click="reUploadFile(index,'3')">
                                            重新上传
                                        </span>
                                        <span class="delete" @click="removeFile(index,'3')">{{ "删除    " }}</span>
                                    </div>
                                </div>
                            </div></el-col
                        >
                    </el-row>
                </el-col>
                <el-col :span="5" :offset="1">
                    <el-upload action="" :multiple="false" :on-change="jyxysUploadChange" :auto-upload="false" :limit="1">
                        <el-button type="primary">上传就业协议书</el-button>
                    </el-upload>
                    <el-row>
                        <el-col :span="24"
                            ><div class="file-upload" v-if="jyxysFileFailList.length > 0 || jyxysFileSuccessList.length > 0">
                                <div class="success">
                                    <div>上传成功文件</div>
                                    <div v-for="(item, index) in jyxysFileSuccessList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span class="delete" @click="deleteFile(index,'4')">删除</span>
                                    </div>
                                </div>
                                <div class="fail" v-if="jyxysFileFailList.length > 0">
                                    <div>上传失败文件</div>
                                    <div v-for="(item, index) in jyxysFileFailList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span style="color: #2a8ae0; cursor: pointer" @click="reUploadFile(index,'4')">
                                            重新上传
                                        </span>
                                        <span class="delete" @click="removeFile(index,'4')">{{ "删除    " }}</span>
                                    </div>
                                </div>
                            </div></el-col
                        >
                    </el-row>
                </el-col> -->
            </el-row>
            <el-row>
                <el-col :span="2" :offset="22">
                    <el-button type="primary" v-show="editFileing" @click="submitFile">提交</el-button>
                    <el-button type="primary" v-show="editing" @click="submitModification">提交修改</el-button>
                </el-col>
            </el-row>
        </el-form>
        <search-university-dialog @choiceData="choiceUniversity" ref="searchUniversityDialog" />
        <search-major-dialog @choiceData="choiceMajor" ref="searchMajorDialog" />
        <search-gw-dialog @choiceData="choiceGw" ref="searchGwDialog" />
    </div>
</template>

<script>
import share from "@/assets/sharejs/share.js";
import request from "@/api/personCenter.js";
import { provinceAndCityData } from "element-china-area-data";
import searchUniversityDialog from '@/views/postList/components/searchUniversityDialog.vue';
import searchMajorDialog from '@/views/postList/components/searchMajorDialog.vue';
import searchGwDialog from '@/views/postList/components/searchGwDialog.vue';

export default {
    mounted() {
        if (this.zplb == '2') {
            //高技能人才招聘学历
            this.options = {
                ...this.options,
                educationList: [
                    {key: '61', value: '技工学校'},
                    {key: '40', value: '中等专科'},
                    {key: '30', value: '大学专科'},
                    {key: '20', value: '大学本科'},
                    {key: '21', value: '大学本科（职业类）'},
                    {key: '14', value: '硕士研究生'},
                    {key: '99', value: '其他'}
                ],
            }
        }else {
            //高校毕业生招聘学历
            this.options = {
                ...this.options,
                educationList: [
                    {key: '20', value: '大学本科'},
                    {key: '14', value: '硕士研究生'},
                    {key: '11', value: '博士研究生'}
                ],
            }
        }
    },
    props: {
        formData: {
            type: Object,
        },
        zplb: {
            type: String,
        }
    },
    components: {
        searchUniversityDialog,
        searchMajorDialog,
        searchGwDialog,
    },
    data() {
        var isMobileNumber = (rule, value, callback) => {
            if (!value) {
                return new Error("请输入手机号码");
            } else {
                const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
                const isPhone = reg.test(value);
                value = Number(value); //转换为数字
                if (typeof value === "number" && !isNaN(value)) {//判断是否为数字
                    value = value.toString(); //转换成字符串
                    if (value.length < 0 || value.length > 12 || !isPhone) { //判断是否为11位手机号
                        callback(new Error("请输入正确的手机号码"));
                    } else {
                        callback();
                    }
                } else {
                    callback(new Error("请输入手机号码"));
                }
            }
        };
        return {
            provinceAndCityData,
            zpzyLov: {
                show: false, //是否显示招聘专业/岗位-查询/选择模态框
                table: [], //岗位查询结果
                zpjhmc: "", //招聘计划名称
                zylb: "", //专业类别
                gwlb: "", //岗位类别
                ssbk: "", //所属板块
                ssbkOptions: share.get("ssbk"), // 所属板块列表
            },
            editing: false, // 是否正在修改编辑
            editFileing: false, // 是否正在更新文件
            detailMessage: ["查看报名信息", "收起报名信息"],
            cloneForm: {}, //用于复制form，以便修改时，数据复原
            showDetails: false, //显示或收起报名信息
            uploadSuccess: false, //是否上传成功
            fileList: [], //附件上传文件列表
            fileFailList: [], //附件上传失败列表
            fileSuccessList: [], //附件上传成功列表
            qzjlFileFailList: [], //求职简历附件上传失败列表
            qzjlFileSuccessList: [], //求职简历附件上传成功列表
            cjbFileFailList: [], //成绩表附件上传失败列表
            cjbFileSuccessList: [], //成绩表附件上传成功列表
            jytjbFileFailList: [], //就业推荐表附件上传失败列表
            jytjbFileSuccessList: [], //就业推荐表附件上传成功列表
            jyxysFileFailList: [], //就业协议书附件上传失败列表
            jyxysFileSuccessList: [], //就业协议书附件上传成功列表

            showMessage: false, //是否显示上传照片图片信息
            showByxxSearchButton: true, //是否显示毕业学校查询按钮
            showSxzySearchButton: true, //是否显示所学专业查询按钮

            form: {
                zpjhmc: "", //招聘计划名称
                zpjhbmid: "", //招聘计划报名id
                zpjhid: "", //招聘计划id
                gwlb: "", //岗位类别
                zpzyid: "", //招聘专业id
                yhid: "", //用户id
                xm: "", //姓名
                sfzhm: "", //身份证号
                xb: "", //性别
                mz: "", //民族
                csny: "", //出生年月
                zzmm: "", //政治面貌
                lxdh: "", //联系电话
                jg: "", //籍贯
                // jltdsj: "", //简历投递时间
                bysj: "", //毕业时间
                zw: "", //职务
                hjqkjtc: "", //获奖情况及特长
                yysp: "", //英语水平
                jsjsp: "", //计算机水平
                dyxl: "", //第一学历
                dyxlbyxx: "", //第一学历毕业学校
                dyxlsxzy: "", //第一学历所学专业
                dyxlsxzydm: "", //第一学历所学专业代码
                // hxxl: "", //后续学历
                // hxxlbyxx: "", //后续学历毕业学校
                // hxxlsxzy: "", //后续学历所学专业
                xxlb: "", //学校类别
                jyxs: "", // 教育形式
                sg: "", //身高
                tz: "", //体重
                zylb: "", //专业类别
                bmbk: "", //报名板块
                bmbkid: "", //报名板块id
                bz: "", //备注（学习经历、社会实践等）
                imageSrc: "", //图片
                gwlbmc: "",
                gwlbid: "",
                zyyjfx: "", //研究方向
                rxsj: "", //入学时间
                sfyfbyjl: "", //是否有服兵役经历
                fbykssj: "", //服兵役开始时间
                fbyjssj: "", //服兵役结束时间
                sfgwyx: "", //是否国外院校
                bkbyxx: "", //本科毕业学校
                bksxzy: "", //本科所学专业
            },
            rules: {
                xm: [
                    {
                        required: true,
                        message: "请输入姓名",
                        trigger: ["blur", "change"],
                    },
                ],
                sfzhm: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: ["blur", "change"],
                    },
                ],
                xb: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: ["blur", "change"],
                    },
                ],
                mz: [
                    {
                        required: true,
                        message: "请选择民族",
                        trigger: ["blur", "change"],
                    },
                ],
                csny: [
                    {
                        required: true,
                        message: "请选择出生年月",
                        trigger: ["blur", "change"],
                    },
                ],
                zzmm: [
                    {
                        required: true,
                        message: "请选择政治面貌",
                        trigger: ["blur", "change"],
                    },
                ],
                jg: [
                    {
                        required: true,
                        message: "请输入籍贯",
                        trigger: ["blur", "change"],
                    },
                ],
                bysj: [
                    {
                        required: true,
                        message: "请选择毕业时间",
                        trigger: ["blur", "change"],
                    },
                ],
                dyxl: [
                    {
                        required: true,
                        message: "请选择第一学历",
                        trigger: ["blur", "change"],
                    },
                ],
                dyxlbyxx: [
                    {
                        required: true,
                        message: "请输入第一学历毕业学校",
                        trigger: ["blur", "change"],
                    },
                ],
                dyxlsxzy: [
                    {
                        required: true,
                        message: "请输入第一学历所学专业",
                        trigger: ["blur", "change"],
                    },
                ],
                lxdh: [
                    {
                        required: true,
                        message: "请输入联系电话",
                        trigger: ["blur", "change"],
                    },
                    { validator: isMobileNumber, trigger: "blur" }
                ],
                gwlbmc: [
                    {
                        required: true,
                        message: "请选择拟应聘岗位",
                        trigger: ["blur", "change"],
                    },
                ],
                sfgwyx: [
                    {
                        required: true,
                        message: "请选择是否国外院校",
                        trigger: ["blur", "change"],
                    },
                ],
                rxsj: [
                    {
                        required: true,
                        message: "请选择入学时间",
                        trigger: ["blur", "change"],
                    },
                ],
                jyxs: [
                    {
                        required: true,
                        message: "请选择教育形式",
                        trigger: ["blur", "change"],
                    },
                ],
                sfyfbyjl: [
                    {
                        required: true,
                        message: "请选择是否有服兵役经历",
                        trigger: ["blur", "change"],
                    },
                ],
                fbykssj: [
                    {
                        required: false,
                        message: "请选择服兵役开始时间",
                        trigger: ["blur", "change"],
                    }
                ],
                fbyjssj: [
                    {
                        required: false,
                        message: "请选择服兵役结束时间",
                        trigger: ["blur", "change"],
                    }
                ]
            },
            options: {
                genderList: share.get("xb"),
                nationList: share.get("mz"),
                politicsFaceList: share.get("zzmm"),
                educationList: share.get("xl"),
                yyspList: share.get("yysp"),
                jsjspList: share.get("jsjsp"),
                collegeList: share.get("lb"), //学校类别
                jyxsList: share.get("jyxs"), // 教育形式
                sfgwyxList: share.get("whether"), //是否国外院校
                sfyfbyjlList: share.get("whether"), //是否有服兵役经历
            },
        };
    },
    watch: {
        formData: {
            handler: function(newValue) {
                this.handlePropsData(newValue);
            },
            immediate: true,
        },
        "form.sfzhm": function(newValue) {
            if (newValue.length == 18) {
                this.form.xb = parseInt(newValue.substr(16, 1)) % 2 == 1 ? "1" : "2"; //奇数男，偶数女
                this.form.csny = newValue.substr(6, 4) + "-" + newValue.substr(10, 2) + "-" + newValue.substr(12, 2);
            }
        },
        "form.imageSrc": function(newValue) {
            if (newValue == "") {
                this.showMessage = true;
            } else {
                this.showMessage = false;
            }
        },
    },
    methods: {
        searchUniversity(queryType){
            let xxmc = "";
            if ("dyxlbyxx" === queryType) {
                xxmc = this.form.dyxlbyxx;
            }
            if ("bkbyxx" === queryType) {
                xxmc = this.form.bkbyxx;
            }
            const data = {
                xxmc: xxmc,
                queryType: queryType
            }
            console.log('data>>>', data)
            this.$refs.searchUniversityDialog.open(data);
        },
        choiceUniversity(data){
            console.log('choiceUniversity>>>', data);
            if ('dyxlbyxx' === data.queryType) {
                this.form.dyxlbyxx = data.xxmc;
                this.form.xxlb = data.yxlb;
            }else {
                this.form.bkbyxx = data.xxmc;
            }
        },
        changeDyxl(){
            if (this.zplb == '2') {
                //高技能人才招聘
                //国外院校时，毕业学校、所学专业手动录入
                if (this.form.sfgwyx == '1') {
                    this.showByxxSearchButton = false;
                    this.showSxzySearchButton = false;
                    this.form.xxlb = "4";
                    if (this.form.dyxl == "99") {
                        this.form.dyxlsxzy = "无";
                    }else {
                        this.form.dyxlsxzy = "";
                    }
                    this.form.dyxlsxzydm = "";
                    this.form.dyxlbyxx = "";
                }else {
                    //非国外院校时
                    if (this.form.dyxl == "61") {
                        //学历是技工学校
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = false;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    } else if (this.form.dyxl == "40") {
                        //学历是中等专科
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = true;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    } else if (this.form.dyxl == "99") {
                        //学历是其他
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = false;
                        this.form.dyxlsxzy = "无";
                        this.form.dyxlsxzydm = "";
                    } else {
                        this.showByxxSearchButton = true;
                        this.showSxzySearchButton = true;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    }
                    this.form.xxlb = "";
                }
                this.form.bkbyxx = "";
                this.form.bksxzy = "";
                this.form.bksxzydm = "";
            }else {
                //高校毕业生招聘
                //学历改变时，专业信息重置，本科毕业学校、本科所学专业重置
                this.form.dyxlsxzy = "";
                this.form.dyxlsxzydm = "";
                this.form.bkbyxx = "";
                this.form.bksxzy = "";
                this.form.bksxzydm = "";
            }
        },
        changeDyxlsxzy(){
            this.form.dyxlsxzydm = "";
        },
        changeSfgwyx() {
            if (this.zplb == "2") {
                //高技能人才招聘
                //国外院校时，毕业学校、所学专业手动录入
                if (this.form.sfgwyx == "1") {
                    this.showByxxSearchButton = false;
                    this.showSxzySearchButton = false;
                    this.form.xxlb = "4";
                    if (this.form.dyxl == "99") {
                        this.form.dyxlsxzy = "无";
                    }else {
                        this.form.dyxlsxzy = "";
                    }
                    this.form.dyxlsxzydm = "";
                    this.form.dyxlbyxx = "";
                }else {
                    //非国外院校时
                    if (this.form.dyxl == "61") {
                        //学历是技工学校
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = false;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    } else if (this.form.dyxl == "40") {
                        //学历是中等专科
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = true;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    } else if (this.form.dyxl == "99") {
                        //学历是其他
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = false;
                        this.form.dyxlsxzy = "无";
                        this.form.dyxlsxzydm = "";
                    } else {
                        this.showByxxSearchButton = true;
                        this.showSxzySearchButton = true;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    }
                    this.form.xxlb = "";
                }
                this.form.dyxlbyxx = "";
            }else {
                //高校毕业生招聘
                if (this.form.sfgwyx == "1") {
                    this.showByxxSearchButton = false;
                    this.showSxzySearchButton = false;
                    this.form.xxlb = "4";
                }else {
                    this.showByxxSearchButton = true;
                    this.showSxzySearchButton = true;
                    this.form.xxlb = "";
                }

                //重置毕业学校、所学专业
                this.form.dyxlbyxx = "";
                this.form.dyxlsxzy = "";
                this.form.dyxlsxzydm = "";
            }
        },
        changeSfyfbyjl() {
            this.form.fbykssj = "";
            this.form.fbyjssj = "";
        },
        searchMajor(){
            if(!this.form.dyxl){
                this.$message({
                    type: "warning",
                    message: "请选择学历",
                });

                return;
            }

            let zylb = "";
            if(this.form.dyxl == "11" || this.form.dyxl == "14"){
                zylb = "1";
            } else if(this.form.dyxl == "20"){
                zylb = "2";
            } else if(this.form.dyxl == "30"){
                zylb = "3";
            }  else if(this.form.dyxl == "21"){
                zylb = "4"
            } else if(this.form.dyxl == "40" || this.form.dyxl == "61"){
                zylb = "5"
            }
            this.$refs.searchMajorDialog.open({
                keyword:this.form.dyxlsxzy,
                zylb: zylb,
                queryType: "dyxlsxzy"
            });
        },
        searchBkMajor() {
            this.$refs.searchMajorDialog.open({
                keyword: this.form.bksxzy,
                zylb: '2',
                queryType: "bksxzy"
            });
        },
        choiceMajor(data){
            const queryType = data.queryType;
            if ("dyxlsxzy" === queryType) {
                this.form.dyxlsxzy = data.zymc;
                this.form.dyxlsxzydm = data.zydm;
            }else {
                this.form.bksxzy = data.zymc;
                this.form.bksxzydm = data.zydm;
            }
        },
        searchGw(){
            this.$refs.searchGwDialog.open({
                keyword: this.form.gwlbmc,
                zphdid: this.form.zpjhid,
            });
        },
        choiceGw(data){
            this.form.gwlbid = data.zpzyid;
            this.form.gwlbmc = data.zylb + "-" + data.ssbk;
        },
        /**
         * 提交修改信息
         */
        submitModification() {
            if (this.validate()) {
                let param = {
                    yhid: this.form.yhid, //用户id
                    zpjhbmid: this.form.zpjhbmid, //招聘计划报名id
                    zpjhid: this.form.zpjhid, //招聘计划id
                    zpzyid: this.form.zpzyid, //招聘专业id
                    ...this.getData(),
                };
                request
                    .modifyBmxx(param)
                    .then((res) => {
                        console.log("修改成功");
                        console.log("提交修改信息>>>>", res);
                        console.log("提交修改信息>>>>", param);
                        this.editing = false;
                        this.fileSuccessList = [];
                        this.fileFailList = [];
                        this.$emit("updated");
                        this.$message({
                            message: "修改成功",
                            type: "success",
                            showClose: true,
                        });
                    })
                    .catch((err) => {
                        console.log("error");
                        console.log(err);
                    });
            }
        },
        /**
         * 提交附件信息
         */
        submitFile() {
            if(this.qzjlFileSuccessList.length == 0 && this.cjbFileSuccessList.length == 0
                && this.jytjbFileSuccessList.length == 0 && this.jyxysFileSuccessList.length == 0){
                    this.editFileing = false;

                    this.qzjlFileFailList = [];
                    this.cjbFileFailList = [];
                    this.jytjbFileFailList = [];
                    this.jyxysFileFailList = [];
            } else {
                let qzjl_fjxxid = "", cjb_fjxxid = "", jytjb_fjxxid = "", jyxys_fjxxid = "";
                if(this.qzjlFileSuccessList.length > 0){
                    qzjl_fjxxid = this.qzjlFileSuccessList[0].fjxxid;
                }
                if(this.cjbFileSuccessList.length > 0){
                    cjb_fjxxid = this.cjbFileSuccessList[0].fjxxid;
                }
                if(this.jytjbFileSuccessList.length > 0){
                    jytjb_fjxxid = this.jytjbFileSuccessList[0].fjxxid;
                }
                if(this.jyxysFileSuccessList.length > 0){
                    jyxys_fjxxid = this.jyxysFileSuccessList[0].fjxxid;
                }
                let param = {
                    zpjhbmid: this.form.zpjhbmid, //招聘计划报名id
                    qzjl_fjxxid: qzjl_fjxxid,
                    cjb_fjxxid: cjb_fjxxid,
                    jytjb_fjxxid: jytjb_fjxxid,
                    jyxys_fjxxid: jyxys_fjxxid,
                };

                request.updateBmxxFileInfo(param).then(() => {
                    this.editFileing = false;

                    this.qzjlFileFailList = [];
                    this.cjbFileFailList = [];
                    this.jytjbFileFailList = [];
                    this.jyxysFileFailList = [];

                    this.qzjlFileSuccessList = [];
                    this.cjbFileSuccessList = [];
                    this.jytjbFileSuccessList = [];
                    this.jyxysFileSuccessList = [];

                    this.$emit("updated");
                    this.$message({
                        message: "更新成功",
                        type: "success",
                        showClose: true,
                    });
                }).catch((err) => {
                    console.log("error");
                    console.log(err);
                });
            }
        },
        /**
         * 弹框表格某一行双击回填
         */
        tableRowDbclickBackfill(row) {
            this.form.zylb = row.zylb; //专业类别
            this.form.bmbk = row.ssbkmc; //报名板块
            this.form.zpzyid = row.zpzyid; //招聘专业id
            this.zpzyLov.show = false;
        },
        /**
         * 查询招聘专业
         */
        queryZpzy() {
            let param = {
                zpjhid: this.form.zpjhid, //招聘计划id
                ssbk: this.zpzyLov.ssbk, //所属板块
                gwlb: this.zpzyLov.gwlb, //岗位类别
                zylb: this.zpzyLov.zylb, //专业类别
            };
            request
                .queryZpzyInfo(param)
                .then((res) => {
                    this.zpzyLov.table = res.vds.map((ele) => {
                        ele.ssbkmc = share.getValue("ssbk", ele.ssbk);
                        return ele;
                    });
                    console.log("success");
                    console.log("查询信息>>>>>" + res);
                })
                .catch((err) => {
                    console.log("error");
                    console.log(err);
                });
        },
        /**
         * 修改报名信息
         */
        modifyRegisInfo() {
            console.log('zgsc>>>', this.formData.zgsc)
            if(this.formData.zgsc != "0"){
                this.$message({
                    message: "报名信息已审核，不允许修改",
                    type: "warning",
                });

                return;
            }
            //如果当前是正在修改，则表示改为不可编辑，并将数据复原；否则，拷贝一份原数据，以便下次复原
            if (this.editing) {
                this.form = this.cloneForm;
            } else {
                // this.cloneForm = Object.assign({}, this.form);
                this.cloneForm = JSON.parse(JSON.stringify(this.form));
            }
            this.editing = !this.editing;
            this.showDetails = true;
        },

        /**
         * 更新附件信息
         */
        modifyFileInfo() {
            //如果当前是正在修改，则表示改为不可编辑，并将数据清空
            if (this.editFileing) {
                this.qzjlFileSuccessList.forEach((item, index)=>{
                    this.deleteFile(index, '1');
                });
                this.cjbFileSuccessList.forEach((item, index)=>{
                    this.deleteFile(index, '2');
                });
                this.jytjbFileSuccessList.forEach((item, index)=>{
                    this.deleteFile(index, '3');
                });
                
                this.qzjlFileFailList = [];
                this.cjbFileFailList = [];
                this.jytjbFileFailList = [];
            }
            this.editFileing = !this.editFileing;
            this.showDetails = true;
        },

        /**
         * 删除报名信息
         */
        deleteRegisInfo() {
            this.$confirm("确认删除本条报名信息?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let param = {
                        zpjhbmid: this.form.zpjhbmid,
                    };
                    request
                        .deleteBmxx(param)
                        .then((res) => {
                            this.$message({
                                message: "删除成功",
                                type: "success",
                                showClose: true,
                            });
                            this.$emit("deleted");
                            console.log("success");
                            console.log(res);
                        })
                        .catch((err) => {
                            console.log("error");
                            console.log(err);
                        });
                })
                .catch(() => {});
        },
        /**
         * 显示或隐藏报名信息
         */
        showOrHide() {
            this.showDetails = !this.showDetails;
        },
        /**
         * 将props中传的数据中的日期格式化
         */
        formatPropsDateToFormDate(date) {
            //date要么未空，要么yyyyMMdd，要么yyyy-MM-dd
            if (/\d{8}/.test(date)) {
                return date.substr(0, 4) + "-" + date.substr(4, 2) + "-" + date.substr(6, 2);
            }
            return date;
        },
        /**
         * 处理props传递的数据
         */
        handlePropsData(newValue) {
            this.zpzyLov.zpjhmc = newValue.zpjhmc;

            this.form.zpjhmc = newValue.zpjhmc; //招聘计划名称
            this.form.zpjhid = newValue.zpjhid; //招聘计划id
            this.form.zpjhbmid = newValue.zpjhbmid; //招聘计划报名id
            this.form.zpzyid = newValue.zpzyid; //招聘专业id
            this.form.yhid = newValue.yhid; //用户id

            this.form.xm = newValue.xm; //姓名
            this.form.xb = newValue.xb; //性别
            this.form.mz = newValue.mz; //民族
            this.form.csny = this.formatPropsDateToFormDate(newValue.csrq); //出生日期
            this.form.bysj = this.formatPropsDateToFormDate(newValue.bysj); //毕业时间
            // this.form.jltdsj = this.formatPropsDateToFormDate(newValue.jltdsj); //简历投递时间
            this.form.zzmm = newValue.zzmm; //政治面貌
            this.form.sfzhm = newValue.yxzjhm; //有效证件号码
            this.form.lxdh = newValue.lxdh; //联系电话
            try {
                this.form.jg = JSON.parse(newValue.jg); //籍贯
            } catch (error) {
                this.form.jg = newValue.jg;
            }
            this.form.zw = newValue.zw; //籍贯
            this.form.hjqkjtc = newValue.hjqkjtc; //获奖情况及特长
            this.form.yysp = newValue.yysp; //英语水平
            this.form.jsjsp = newValue.jsjsp; //计算机水平
            this.form.imageSrc = newValue.zp == "" ? "" : "data:image/png;base64," + newValue.zp; //照片
            this.form.zylb = newValue.zylb; //专业类别
            this.form.bmbkid = newValue.ssbk; //报名板块id
            this.form.bmbk = share.getValue("ssbk", newValue.ssbk); //报名板块
            this.form.dyxl = newValue.dyxl; //第一学历
            
            this.form.dyxlbyxx = newValue.dyxlbyxx; //第一学历毕业院校
            this.form.dyxlsxzy = newValue.dyxlzy; //第一学历专业
            this.form.dyxlsxzydm = newValue.dyxlzydm; //第一学历专业
            this.form.xxlb = newValue.xxlb; //学校类别
            this.form.jyxs = newValue.jyxs; //学校类别
            this.form.sg = newValue.sg; //身高
            this.form.tz = newValue.tz; //体重
            // this.form.hxxl = newValue.hxxl; //后续学历
            // this.form.hxxlbyxx = newValue.hxxlbyxx; //后续学历毕业院校这个
            // this.form.hxxlsxzy = newValue.hxxlzy; //后续学历专业

            this.form.gwlbid = newValue.gwlbid; //备注（学习经历、社会实践等）
            this.form.gwlbmc = newValue.gwlbmc; //备注（学习经历、社会实践等）
            this.form.bz = newValue.bz; //备注（学习经历、社会实践等）
            //   this.fileUploadedList = newValue.ds_zpjh_bmxx_fjxx; //已上传文件列表
            this.fileSuccessList = newValue.ds_zpjh_bmxx_fjxx.map((ele) => {
                ele.name = ele.fjmc;
                return ele;
            }); //已上传文件列表

            this.form.rxsj = this.formatPropsDateToFormDate(newValue.rxsj); //入学时间
            this.form.sfyfbyjl = newValue.sfyfbyjl; //是否有服兵役经历
            this.form.fbykssj = this.formatPropsDateToFormDate(newValue.fbykssj); //服兵役开始时间
            this.form.fbyjssj = this.formatPropsDateToFormDate(newValue.fbyjssj); //服兵役结束时间
            this.form.sfgwyx = newValue.sfgwyx; //是否国外院校
            this.form.bkbyxx = newValue.bkbyxx; //本科毕业学校
            this.form.bksxzy = newValue.bksxzy; //本科所学专业
            this.form.zyyjfx = newValue.zyyjfx; //研究方向
            
            //国外院校时，毕业学校、所学专业手动录入
            if (this.form.sfgwyx == "1") {
                this.showByxxSearchButton = false;
                this.showSxzySearchButton = false;
            }else {
                //非国外院校且高技能人才招聘
                if (this.zplb == "2") {
                    if (this.form.dyxl == '61') { //学历是技工学校
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = false;
                    } else if (this.form.dyxl == '40') { //学历是中等专科
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = true;   
                    } else if (this.form.dyxl == '99') { //学历是其他
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = false;
                    } else {
                        this.showByxxSearchButton = true;
                        this.showSxzySearchButton = true;
                    }
                }
            }
        },
        /**
         * 附件删除
         */
        deleteFile(index, type) {
            let fjxxid = "";
            if(type == "1"){
                fjxxid = this.qzjlFileSuccessList[index].fjxxid;
            } else if(type == "2") {
                fjxxid = this.cjbFileSuccessList[index].fjxxid;
            } else if(type == "3") {
                fjxxid = this.jytjbFileSuccessList[index].fjxxid;
            } else if(type == "4") {
                fjxxid = this.jyxysFileSuccessList[index].fjxxid;
            }

            let param = {
                fjxxid: fjxxid,
            };
            request
                .delFile(param)
                .then((res) => {
                    console.log(res);
                    this.$message({
                        message: "删除成功! ",
                        type: "success",
                    });

                    if(type == "1"){
                        this.qzjlFileSuccessList.splice(index, 1);
                    } else if(type == "2") {
                        this.cjbFileSuccessList.splice(index, 1);
                    } else if(type == "3") {
                        this.jytjbFileSuccessList.splice(index, 1);
                    } else if(type == "4") {
                        this.jyxysFileSuccessList.splice(index, 1);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        /**
         * 附件移除（上传失败列表）
         */
        removeFile(index, type) {
            if(type == "1"){
                this.qzjlFileFailList.splice(index, 1);
            } else if(type == "2"){
                this.cjbFileFailList.splice(index, 1);
            } else if(type == "3"){
                this.jytjbFileFailList.splice(index, 1);
            } else if(type == "4"){
                this.jyxysFileFailList.splice(index, 1);
            }
        },
        /**
         * 上传失败的文件重新上传
         */
        reUploadFile(index, type) {
            let fileData = new FormData();
            let item;
            if(type == "1"){
                if(this.qzjlFileSuccessList.length > 0){
                    this.$message({
                        message: "请删除求职简历成功列表中已有的文件再上传此文件",
                        type: "warning",
                    });
                    return;
                }
                item = this.qzjlFileFailList[index];
            } else if(type == "2"){
                if(this.cjbFileSuccessList.length > 0){
                    this.$message({
                        message: "请删除成绩表成功列表中已有的文件再上传此文件",
                        type: "warning",
                    });
                    return;
                }
                item = this.cjbFileFailList[index];
            } else if(type == "3"){
                if(this.jytjbFileSuccessList.length > 0){
                    this.$message({
                        message: "请删除就业推荐表成功列表中已有的文件再上传此文件",
                        type: "warning",
                    });
                    return;
                }
                item = this.jytjbFileFailList[index];
            } else if(type == "4"){
                if(this.jyxysFileSuccessList.length > 0){
                    this.$message({
                        message: "请删除就业协议书成功列表中已有的文件再上传此文件",
                        type: "warning",
                    });
                    return;
                }
                item = this.jyxysFileFailList[index];
            }

            //过滤选出文件名已存在于成功列表的数据
            let repeat = this.fileSuccessList.filter((ele) => {
                return ele.name == item.name;
            });
            if (repeat.length > 0) {
                this.$message({
                    message: "请勿上传重复文件",
                    type: "warning",
                });
                return;
            }
            fileData.append("uploadfile", item.raw);
            fileData.append("filename", encodeURI(item.raw.name));
            // fileData.append("fjly", "28821041610000000043");
            fileData.append("fjlylx", "3");
            request
                .setBMISection(fileData)
                .then((res) => {
                    console.log(res);
                    item.fjxxid = res.fjxxid;

                    if(type == "1"){
                        this.qzjlFileSuccessList.push(item);
                        this.qzjlFileFailList.splice(index, 1);
                    } else if(type == "2"){
                        this.cjbFileSuccessList.push(item);
                        this.cjbFileFailList.splice(index, 1);
                    } else if(type == "3"){
                        this.jytjbFileSuccessList.push(item);
                        this.jytjbFileFailList.splice(index, 1);
                    } else if(type == "4"){
                        this.jyxysFileSuccessList.push(item);
                        this.jyxysFileFailList.splice(index, 1);
                    }
                    this.$message({
                        message: "文件  " + item.raw.name + "  重新上传上传成功! ",
                        type: "error",
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        /**
         * 附件上传
         */
        uploadFile(type) {
            while (this.fileList.length > 0) {
                let fileData = new FormData();
                let item = this.fileList.shift();
                
                fileData.append("uploadfile", item.raw);
                fileData.append("filename", encodeURI(item.raw.name));
                // fileData.append("fjly", this.form.zpjhbmid);
                fileData.append("fjlylx", "3");
                request
                    .uploadFile(fileData)
                    .then((res) => {
                        console.log(res);
                        item.fjxxid = res.fjxxid;

                        if(type == "1"){
                            this.qzjlFileSuccessList.push(item);
                        } else if(type == "2"){
                            this.cjbFileSuccessList.push(item);
                        } else if(type == "3"){
                            this.jytjbFileSuccessList.push(item);
                        } else if(type == "4"){
                            this.jyxysFileSuccessList.push(item);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        // this.$message({
                        //   // message: err,
                        //   message: "文件  " + item.raw.name + "  上传失败! " + err,
                        //   type: "error"
                        // });
                        if(type == "1"){
                            this.qzjlFileFailList.push(item);
                        } else if(type == "2"){
                            this.cjbFileFailList.push(item);
                        } else if(type == "3"){
                            this.jytjbFileFailList.push(item);
                        } else if(type == "4"){
                            this.jyxysFileFailList.push(item);
                        }
                    });
            }
        },
        /**
         * 附件上传
         */
         setBMISection(type) {
            while (this.fileList.length > 0) {
                let fileData = new FormData();
                let item = this.fileList.shift();
                
                fileData.append("uploadfile", item.raw);
                fileData.append("filename", encodeURI(item.raw.name));
                fileData.append("fjlylx", "3");
                if (type == "1") {
                    fileData.append("bmdbh", "qzjl_zpjh");
                    fileData.append("bmdmc", encodeURI("求职简历"));
                }
                if (type == "2") {
                    fileData.append("bmdbh", "cjb_zpjh");
                    fileData.append("bmdmc", encodeURI("成绩表"));
                }
                if (type == "3") {
                    fileData.append("bmdbh", "jytjb_zpjh");
                    fileData.append("bmdmc", encodeURI("就业推荐表"));
                }
                if (type == "4") {
                    fileData.append("bmdbh", "jyxys_zpjh");
                    fileData.append("bmdmc", encodeURI("就业协议书"));
                }
                if (type == "5") {
                    fileData.append("bmdbh", "zp_zpjh");
                    fileData.append("bmdmc", encodeURI("个人照片"));
                }
                
                request
                    .setBMISection(fileData)
                    .then((res) => {
                        console.log(res);
                        item.fjxxid = res.fjxxid;

                        if(type == "1"){
                            this.qzjlFileSuccessList.push(item);
                        } else if(type == "2"){
                            this.cjbFileSuccessList.push(item);
                        } else if(type == "3"){
                            this.jytjbFileSuccessList.push(item);
                        } else if(type == "4"){
                            this.jyxysFileSuccessList.push(item);
                        } else if(type == "5"){
                            this.zpFileSuccessList.push(item);
                            this.getBase64(item.raw).then((src) => {
                                this.form.imageSrc = src;
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        // this.$message({
                        //   // message: err,
                        //   message: "文件  " + item.raw.name + "  上传失败! " + err,
                        //   type: "error"
                        // });
                        if(type == "1"){
                            this.qzjlFileFailList.push(item);
                        } else if(type == "2"){
                            this.cjbFileFailList.push(item);
                        } else if(type == "3"){
                            this.jytjbFileFailList.push(item);
                        } else if(type == "4"){
                            this.jyxysFileFailList.push(item);
                        }
                    });
            }
        },
        /**
         * 附件上传文件添加删除回调方法
         */
        uploadChange(file, fileList) {
            this.fileList = fileList;
            console.log(this.fileList);
            this.uploadFile();
        },
        /**
         * 附件上传文件添加回调方法
         */
        qzjlUploadChange(file, fileList) {
            if(this.qzjlFileSuccessList.length > 0){
                fileList.shift();
                this.$message.error("请删除已上传文件后再上传新文件！");
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传附件大小不能超过 10MB!");
                return;
            }
            console.log('>>>:qzjlUploadChange');
            this.fileList = fileList;
            // this.uploadFile("1");
            this.setBMISection("1");
        },
        cjbUploadChange(file, fileList) {
            if(this.cjbFileSuccessList.length > 0){
                fileList.shift();
                this.$message.error("请删除已上传文件后再上传新文件！");
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传附件大小不能超过 10MB!");
                return;
            }
            console.log('>>>:cjbUploadChange');
            this.fileList = fileList;
            // this.uploadFile("2");
            this.setBMISection("2");
        },
        jytjbUploadChange(file, fileList) {
            if(this.jytjbFileSuccessList.length > 0){
                fileList.shift();
                this.$message.error("请删除已上传文件后再上传新文件！");
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传附件大小不能超过 10MB!");
                return;
            }
            console.log('>>>:jytjbUploadChange');
            this.fileList = fileList;
            // this.uploadFile("3");
            this.setBMISection("3");
        },
        jyxysUploadChange(file, fileList) {
            if(this.jyxysFileSuccessList.length > 0){
                fileList.shift();
                this.$message.error("请删除已上传文件后再上传新文件！");
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传附件大小不能超过 10MB!");
                return;
            }
            console.log('>>>:jyxysUploadChange');
            this.fileList = fileList;
            // this.uploadFile("4");
            this.setBMISection("4");
        },
        /**
         * 父组件获取校验后的数据
         */
        getData() {
            let data = {
                xm: this.form.xm, //姓名
                xb: this.form.xb, //性别
                mz: this.form.mz, //民族
                csrq: this.form.csny, //出生日期
                zzmm: this.form.zzmm, //政治面貌
                yxzjhm: this.form.sfzhm, //有效证件号码
                lxdh: this.form.lxdh, //联系电话
                jg: this.form.jg instanceof Array ? JSON.stringify(this.form.jg) : this.form.jg, //家庭住址
                zp: this.form.imageSrc.split(",")[1], //照片

                dyxl: this.form.dyxl, //第一学历
                dyxlbyxx: this.form.dyxlbyxx, //第一学历毕业学校
                dyxlzy: this.form.dyxlsxzy, //第一学历专业
                dyxlzydm: this.form.dyxlsxzydm, //第一学历专业
                xxlb: this.form.xxlb, //学校类别
                jyxs: this.form.jyxs, // 教育形式
                sg: this.form.sg, //身高
                tz: this.form.tz, //体重
                // hxxl: this.form.hxxl, //后续学历
                // hxxlbyxx: this.form.hxxlbyxx, //后续学历毕业院校
                // hxxlzy: this.form.hxxlsxzy, //后续学历专业

                yysp: this.form.yysp, //英语水平
                jsjsp: this.form.jsjsp, //计算机水平
                bysj: this.form.bysj, //毕业时间
                jltdsj: this.form.jltdsj, //简历投递时间
                zw: this.form.zw, //职务
                hjqkjtc: this.form.hjqkjtc, //获奖情况及特长
                zpzyid: this.form.gwlbid, //拟应聘岗位
                bz: this.form.bz, //备注

                zyyjfx: this.form.zyyjfx, //研究方向
                rxsj: this.form.rxsj, //入学时间
                sfyfbyjl: this.form.sfyfbyjl, //是否有服兵役经历
                fbykssj: this.form.fbykssj, //服兵役开始时间
                fbyjssj: this.form.fbyjssj, //服兵役结束时间
                sfgwyx: this.form.sfgwyx, //是否国外院校
                bkbyxx: this.form.bkbyxx, //本科毕业学校
                bksxzy: this.form.bksxzy, //本科所学专业
            };
            return data;
        },
        /**
         * 校验数据是否都已填写
         */
        validate() {
            let validated = false;
            this.$refs.form.validate((valid) => {
                if (valid) {
                    validated = true;
                } else {
                    validated = false;
                }
            });
            //检查是否选择专业
            if(this.showSxzySearchButton && this.form.dyxlsxzydm == ""){
                this.$message({
                    message: "请点击放大镜选择所学专业",
                    type: "warning",
                });
                validated = false;
            }
            //检查是否选择岗位
            if(this.form.gwlbid == ""){
                this.$message({
                    message: "请点击放大镜选择拟应聘岗位",
                    type: "warning",
                });
                validated = false;
            }
            //检查是否已选择照片
            if (this.form.imageSrc == "") {
                this.showMessage = true;
                validated = false;
            } else {
                this.showMessage = false;
            }
            return validated;
        },
        imageChange(file) {
            const isLt2M = file.size / 1024 / 1024 < 0.2;
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 200kb!");
                return;
            }

            let that = this;
            this.getBase64(file.raw).then((src) => {
                that.form.imageSrc = src;
            });
            // fileList = [];
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                let imageSrc;
                reader.readAsDataURL(file);
                reader.onload = function() {
                    imageSrc = reader.result;
                };
                reader.onloadend = function() {
                    resolve(imageSrc);
                };
                reader.onerror = function(err) {
                    reject(err);
                };
            });
        },
    },
};
</script>

<style lang="scss">
.file-upload {
    display: flex;
    justify-content: space-between;
    .success {
        color: #12c3af;
    }
    .uploaded {
        display: flex;
        justify-content: space-between;
    }
    .fail {
        color: #f56c6c;
    }
}
.baseinfo-image {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    .image {
        margin: 10px;
        padding: 7px;
        width: 150px;
        height: 180px;
    }
}
.regisInfo {
    margin: 20px 0 0 0;
    background-color: #f2f2f2;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
        .title {
            font-weight: bold;
            margin-bottom: 20px;
        }
        .info {
            margin-bottom: 20px;
        }
    }
    .view {
        align-self: flex-end;
        color: #2a8ae0;
        &:hover {
            cursor: pointer;
        }
    }
    .right {
        color: #2a8ae0;
        span {
            margin: 0px 20px;
        }
        &:hover {
            cursor: pointer;
        }
    }
}
.red {
    color: #f56c6c;
}
.show {
    display: block;
}
.hide {
    display: none;
}
.header {
    font-weight: bold;
    padding: 10px;
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.modify {
    color: #2a8ae0;
    &:hover {
        cursor: pointer;
    }
}
.delete {
    color: #ff5858;
    min-width: 30px;
    &:hover {
        cursor: pointer;
    }
}
</style>
